import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('ErrorBoundary caught:', error, errorInfo);
    // Send to server so we can diagnose from PM2 logs
    try {
      const payload = {
        error: error?.toString() || 'unknown',
        componentStack: errorInfo?.componentStack || '',
        url: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      };
      fetch('/api/log-client-error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      }).catch(() => {});
    } catch (_) {}
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback(this.state.error, () => {
          this.setState({ hasError: false, error: null, errorInfo: null });
          if (this.props.onReset) this.props.onReset();
        });
      }
      return (
        <div style={{ minHeight: '100vh', background: 'var(--cream)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="card" style={{ padding: '40px', maxWidth: '600px', textAlign: 'center' }}>
            <h2 style={{ color: 'var(--red)', marginBottom: '16px' }}>Something went wrong</h2>
            <p style={{ color: 'var(--gray)', marginBottom: '20px' }}>
              {this.props.message || 'An unexpected error occurred. Please try refreshing the page.'}
            </p>
            <details style={{ textAlign: 'left', marginBottom: '20px', fontSize: '12px', color: '#666', background: '#f5f5f5', padding: '12px', borderRadius: '8px', maxHeight: '200px', overflow: 'auto' }}>
              <summary style={{ cursor: 'pointer', fontWeight: 600 }}>Error details</summary>
              <pre style={{ whiteSpace: 'pre-wrap', marginTop: '8px' }}>{this.state.error?.toString()}</pre>
              {this.state.errorInfo && (
                <pre style={{ whiteSpace: 'pre-wrap', marginTop: '8px', fontSize: '10px' }}>{this.state.errorInfo.componentStack}</pre>
              )}
            </details>
            <button className="btn btn-primary" onClick={() => window.location.reload()}>
              Refresh Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
